module.exports = __webpack_public_path__ + "keyboard_arrow_right-v1-34e9a070.svg";